import { __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ViewEncapsulation, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { getRoute } from '@blue/services/environment';
import { shareReplay, map } from 'rxjs/operators';
import * as i2 from '@bm-uktax/uk-hmrc-fraud-prevention';
import { UkHmrcFraudPreventionService } from '@bm-uktax/uk-hmrc-fraud-prevention';
import { has } from '@blue/services/permission';
import { NgbActiveModal, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BentoModule } from '@bento/bento-ng';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@bm-uktax/uk-hmrc-fraud-prevention';
import * as ɵngcc3 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc4 from '@bento/bento-ng';
import * as ɵngcc5 from '@angular/forms';
import * as ɵngcc6 from '@angular/common';

function UkVatPeriodsAddPeriodComponent_div_19_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 25);
    ɵngcc0.ɵɵtext(1, "Period start date is required");
    ɵngcc0.ɵɵelementEnd();
} }
function UkVatPeriodsAddPeriodComponent_div_19_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 25);
    ɵngcc0.ɵɵtext(1, "Enter the Period start date as dd/mm/yyyy");
    ɵngcc0.ɵɵelementEnd();
} }
function UkVatPeriodsAddPeriodComponent_div_19_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 25);
    ɵngcc0.ɵɵtext(1, "The period end date must be later than the period start date");
    ɵngcc0.ɵɵelementEnd();
} }
function UkVatPeriodsAddPeriodComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵelement(1, "i", 23);
    ɵngcc0.ɵɵtemplate(2, UkVatPeriodsAddPeriodComponent_div_19_span_2_Template, 2, 0, "span", 24);
    ɵngcc0.ɵɵtemplate(3, UkVatPeriodsAddPeriodComponent_div_19_span_3_Template, 2, 0, "span", 24);
    ɵngcc0.ɵɵtemplate(4, UkVatPeriodsAddPeriodComponent_div_19_span_4_Template, 2, 0, "span", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.invalidStartDateError === "required");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.invalidStartDateError === "invalidFormat");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.invalidStartDateError === "endMustBeLaterThanStart");
} }
function UkVatPeriodsAddPeriodComponent_div_30_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 25);
    ɵngcc0.ɵɵtext(1, "Period end date is required");
    ɵngcc0.ɵɵelementEnd();
} }
function UkVatPeriodsAddPeriodComponent_div_30_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 25);
    ɵngcc0.ɵɵtext(1, "Enter the Period end date as dd/mm/yyyy");
    ɵngcc0.ɵɵelementEnd();
} }
function UkVatPeriodsAddPeriodComponent_div_30_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 25);
    ɵngcc0.ɵɵtext(1, "The period end date must be later than the period start date");
    ɵngcc0.ɵɵelementEnd();
} }
function UkVatPeriodsAddPeriodComponent_div_30_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵelement(1, "i", 23);
    ɵngcc0.ɵɵtemplate(2, UkVatPeriodsAddPeriodComponent_div_30_span_2_Template, 2, 0, "span", 24);
    ɵngcc0.ɵɵtemplate(3, UkVatPeriodsAddPeriodComponent_div_30_span_3_Template, 2, 0, "span", 24);
    ɵngcc0.ɵɵtemplate(4, UkVatPeriodsAddPeriodComponent_div_30_span_4_Template, 2, 0, "span", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.invalidEndDateError === "required");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.invalidEndDateError === "invalidFormat");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.invalidEndDateError === "endMustBeLaterThanStart");
} }
const _c0 = function (a0) { return { "uk-vat-add-period-form-control": a0 }; };
const _c1 = ["emptyVatNumberAlertTemplate"];
const _c2 = ["invalidVatNumberAlertTemplate"];
function UkVatPeriodsComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.noPermissionMessage());
} }
function UkVatPeriodsComponent_div_0_div_2_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 14);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r12.loadingError);
} }
function UkVatPeriodsComponent_div_0_div_2_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "uk-vat-periods-user-messages", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("userMessages", ctx_r13.userMessages);
} }
function UkVatPeriodsComponent_div_0_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelement(1, "bento-alert", 13);
    ɵngcc0.ɵɵtemplate(2, UkVatPeriodsComponent_div_0_div_2_div_3_div_2_Template, 4, 1, "div", 0);
    ɵngcc0.ɵɵtemplate(3, UkVatPeriodsComponent_div_0_div_2_div_3_div_3_Template, 2, 1, "div", 0);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("inline", true)("items", ctx_r7.alerts);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.loadingError);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.userMessages == null ? null : ctx_r7.userMessages.length);
} }
function UkVatPeriodsComponent_div_0_div_2_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " VAT periods have been created but are not yet available on HMRC. The status will be automatically updated when they become available. ");
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵelementEnd();
} }
function UkVatPeriodsComponent_div_0_div_2_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " The following open periods are available in HMRC. ");
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵelementEnd();
} }
function UkVatPeriodsComponent_div_0_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtemplate(1, UkVatPeriodsComponent_div_0_div_2_div_4_div_1_Template, 3, 0, "div", 0);
    ɵngcc0.ɵɵtemplate(2, UkVatPeriodsComponent_div_0_div_2_div_4_div_2_Template, 3, 0, "div", 0);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.hasUnavailablePeriods());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r8.hasUnavailablePeriods() && ctx_r8.hasOpenPeriods());
} }
function UkVatPeriodsComponent_div_0_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17)(1, "p", 18);
    ɵngcc0.ɵɵtext(2, " You can create an initial provisional VAT period that will have an HMRC status of \"Not Available\" until the period is synchronised successfully. ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 19);
    ɵngcc0.ɵɵlistener("click", function UkVatPeriodsComponent_div_0_div_2_div_5_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.onAddPeriod(); });
    ɵngcc0.ɵɵelement(4, "i", 20);
    ɵngcc0.ɵɵtext(5, " Add provisional period ");
    ɵngcc0.ɵɵelementEnd()();
} }
function UkVatPeriodsComponent_div_0_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelement(1, "uk-vat-periods-table", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("vat-mt-10", !(ctx_r10.hasUnavailablePeriods() || !ctx_r10.hasUnavailablePeriods() && ctx_r10.hasOpenPeriods()));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("periods", ctx_r10.periods);
} }
function UkVatPeriodsComponent_div_0_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23)(1, "div", 24)(2, "span", 25);
    ɵngcc0.ɵɵtext(3, "Attempting to sync VAT periods with HMRC");
    ɵngcc0.ɵɵelementEnd()()();
} }
function UkVatPeriodsComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelement(1, "uk-vat-periods-vat-number", 5);
    ɵngcc0.ɵɵelementStart(2, "div", 6);
    ɵngcc0.ɵɵtemplate(3, UkVatPeriodsComponent_div_0_div_2_div_3_Template, 4, 4, "div", 7);
    ɵngcc0.ɵɵtemplate(4, UkVatPeriodsComponent_div_0_div_2_div_4_Template, 3, 2, "div", 8);
    ɵngcc0.ɵɵtemplate(5, UkVatPeriodsComponent_div_0_div_2_div_5_Template, 6, 0, "div", 9);
    ɵngcc0.ɵɵtemplate(6, UkVatPeriodsComponent_div_0_div_2_div_6_Template, 2, 3, "div", 10);
    ɵngcc0.ɵɵtemplate(7, UkVatPeriodsComponent_div_0_div_2_div_7_Template, 4, 0, "div", 11);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("vatNumber", ctx_r6.vatNumber);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("vat-sync-content", ctx_r6.isLoading || ctx_r6.isSyncing);
    ɵngcc0.ɵɵproperty("bentoBusyLoader", ctx_r6.isLoading || ctx_r6.isSyncing)("size", "lg");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.alerts.length || (ctx_r6.userMessages == null ? null : ctx_r6.userMessages.length) || ctx_r6.loadingError);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.hasUnavailablePeriods() || !ctx_r6.hasUnavailablePeriods() && ctx_r6.hasOpenPeriods());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.showAddPeriod());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.hasPeriods());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.isLoading || ctx_r6.isSyncing);
} }
function UkVatPeriodsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, UkVatPeriodsComponent_div_0_div_1_Template, 2, 1, "div", 0);
    ɵngcc0.ɵɵtemplate(2, UkVatPeriodsComponent_div_0_div_2_Template, 8, 10, "div", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.hasPermission);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasPermission);
} }
function UkVatPeriodsComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " A VAT number has not been provided for the contact. Add it in the ");
    ɵngcc0.ɵɵelementStart(2, "a", 26);
    ɵngcc0.ɵɵlistener("click", function UkVatPeriodsComponent_ng_template_1_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.navigateToGeneral(); });
    ɵngcc0.ɵɵtext(3, "General tab");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, ". ");
    ɵngcc0.ɵɵelementEnd();
} }
function UkVatPeriodsComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " The VAT Number is invalid. Enter a valid VAT Number in the ");
    ɵngcc0.ɵɵelementStart(2, "a", 27);
    ɵngcc0.ɵɵlistener("click", function UkVatPeriodsComponent_ng_template_3_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.navigateToGeneral(); });
    ɵngcc0.ɵɵtext(3, "General tab");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, ". ");
    ɵngcc0.ɵɵelementEnd();
} }
function UkVatPeriodsTableComponent_tr_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr")(1, "td");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "td");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "td");
    ɵngcc0.ɵɵelement(8, "uk-vat-period-status-display", 4);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const period_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(3, 3, period_r1.start, "dd/MM/yyyy"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(6, 6, period_r1.end, "dd/MM/yyyy"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("period", period_r1);
} }
class VatPeriodsResponse {
    constructor(periods, userMessages) {
        this.periods = periods;
        this.userMessages = userMessages;
    }
}

class UkVatPeriodsUtilsService {
    isNumber(value) {
        return !isNaN(this.toInteger(value));
    }
    toInteger(value) {
        return parseInt(`${value}`, 10);
    }
    padNumber(value) {
        if (this.isNumber(value)) {
            return `0${value}`.slice(-2);
        }
        return '';
    }
    formatDateForUrl(date) {
        if (!date) {
            return '';
        }
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return `${year}-${this.padNumber(month)}-${this.padNumber(day)}`;
    }
    ngbDateStructToDate(ngbDate) {
        if (!ngbDate) {
            return null;
        }
        // for some reason, we sometimes see the date come in as a JS Date object,
        // so if it is that then just return it
        if (ngbDate instanceof Date) {
            return ngbDate;
        }
        const date = new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
        const year = date.getFullYear();
        return (year < 2000 || year > 3000) ? null : date;
    }
}
UkVatPeriodsUtilsService.ɵfac = function UkVatPeriodsUtilsService_Factory(t) { return new (t || UkVatPeriodsUtilsService)(); };
UkVatPeriodsUtilsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function UkVatPeriodsUtilsService_Factory() { return new UkVatPeriodsUtilsService(); }, token: UkVatPeriodsUtilsService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkVatPeriodsUtilsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class UkVatPeriodsService {
    constructor(http, ukHmrcFraudPreventionService, utilsService) {
        this.http = http;
        this.ukHmrcFraudPreventionService = ukHmrcFraudPreventionService;
        this.utilsService = utilsService;
    }
    getVatPeriodsByContactId(contactId, sync) {
        return __awaiter(this, void 0, void 0, function* () {
            const [basePath, options] = yield this.getRequestConfig();
            const url = `${basePath}/v1/periods/${contactId}${sync ? '/sync' : ''}`;
            return this.http
                .get(url, options)
                .pipe(shareReplay(1), // New subscriptions will not trigger a new request
            map((response) => new VatPeriodsResponse(response.data.items, response.userMessages)))
                .toPromise();
        });
    }
    getVatNumberByContactId(contactId) {
        return __awaiter(this, void 0, void 0, function* () {
            const [basePath, options] = yield this.getRequestConfig();
            const url = `${basePath}/v1/vat-details/contact/${contactId}/vat-number`;
            return this.http
                .get(url, options)
                .pipe(shareReplay(1), // New subscriptions will not trigger a new request
            map((response) => response.data.items[0]))
                .toPromise();
        });
    }
    getShowVatTabByContactId(contactId) {
        return __awaiter(this, void 0, void 0, function* () {
            const [basePath, options] = yield this.getRequestConfig();
            const url = `${basePath}/v2/vat-details/contact/${contactId}/enabled`;
            return this.http
                .get(url, options)
                .pipe(shareReplay(1), // New subscriptions will not trigger a new request
            map((response) => response.data.items[0].enabled))
                .toPromise();
        });
    }
    addNewProvisionalPeriod(contactId, startDate, endDate) {
        return __awaiter(this, void 0, void 0, function* () {
            const [basePath, options] = yield this.getRequestConfig();
            const formatedStartDate = this.utilsService.formatDateForUrl(startDate);
            const formatedEndDate = this.utilsService.formatDateForUrl(endDate);
            const url = `${basePath}/v1/periods/${contactId}?start=${formatedStartDate}&end=${formatedEndDate}`;
            return this.http
                .post(url, null, options)
                .pipe(shareReplay(1), // New subscriptions will not trigger a new request
            map((response) => response.data.items))
                .toPromise();
        });
    }
    getRequestConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.all([this.getBasePath(), this.getRequestOptions()]);
        });
    }
    getBasePath() {
        return __awaiter(this, void 0, void 0, function* () {
            const path = yield getRoute('UKVATServices');
            return this.stripDomainName(path);
        });
    }
    getRequestOptions() {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = yield this.ukHmrcFraudPreventionService.getHeaders();
            return { headers };
        });
    }
    stripDomainName(route) {
        let routeSegments = route.split('/');
        routeSegments = routeSegments.slice(3, routeSegments.length);
        return `/${routeSegments.join('/')}`;
    }
}
UkVatPeriodsService.ɵfac = function UkVatPeriodsService_Factory(t) { return new (t || UkVatPeriodsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.UkHmrcFraudPreventionService), ɵngcc0.ɵɵinject(UkVatPeriodsUtilsService)); };
UkVatPeriodsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function UkVatPeriodsService_Factory() { return new UkVatPeriodsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.UkHmrcFraudPreventionService), i0.ɵɵinject(UkVatPeriodsUtilsService)); }, token: UkVatPeriodsService, providedIn: "root" });
UkVatPeriodsService.ctorParameters = () => [
    { type: HttpClient },
    { type: UkHmrcFraudPreventionService },
    { type: UkVatPeriodsUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkVatPeriodsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.UkHmrcFraudPreventionService }, { type: UkVatPeriodsUtilsService }]; }, null); })();

var AlertItemOptionsTypes;
(function (AlertItemOptionsTypes) {
    AlertItemOptionsTypes["success"] = "success";
    AlertItemOptionsTypes["info"] = "info";
    AlertItemOptionsTypes["warning"] = "warning";
    AlertItemOptionsTypes["danger"] = "danger";
})(AlertItemOptionsTypes || (AlertItemOptionsTypes = {}));

class UkVatAlertService {
    constructor() {
        this.onAlertAdded = new EventEmitter();
        this.clearAll = new EventEmitter();
    }
    /**
     * Adds danger alert
     */
    addDangerAlert(msg) {
        this.addAlert(AlertItemOptionsTypes.danger, msg);
    }
    addAlert(type, msg) {
        const option = {
            type,
            msg,
            closeable: true,
        };
        this.onAlertAdded.emit(option);
    }
}
UkVatAlertService.ɵfac = function UkVatAlertService_Factory(t) { return new (t || UkVatAlertService)(); };
UkVatAlertService.ɵprov = i0.ɵɵdefineInjectable({ factory: function UkVatAlertService_Factory() { return new UkVatAlertService(); }, token: UkVatAlertService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkVatAlertService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class UkVatDateValidatorService {
    constructor(utilsService) {
        this.utilsService = utilsService;
    }
    validatePeriodDate(ngbStartDate, ngbEndDate, isStartDate) {
        const startDate = this.utilsService.ngbDateStructToDate(ngbStartDate);
        const endDate = this.utilsService.ngbDateStructToDate(ngbEndDate);
        const ngbDate = isStartDate ? ngbStartDate : ngbEndDate;
        return ngbDate && !this.validateDate(ngbDate) ?
            'invalidFormat' : (!ngbDate ? 'required' :
            (startDate && endDate && startDate >= endDate ? 'endMustBeLaterThanStart' : ''));
    }
    /**
     * Synchronize the period dates validation if the period start date is later then periods end date
     * In this case validation message should be displayed under both fields simultaneously
     * if both of them are valid
     */
    syncPeriodValidation(editedDateError, dateError) {
        return editedDateError === 'endMustBeLaterThanStart' ?
            'endMustBeLaterThanStart' : dateError === 'endMustBeLaterThanStart' ? '' : dateError;
    }
    validateDate(date) {
        if (!date) {
            return false;
        }
        // If the NGB DatePicker isn't able to validate a date, it returns a pure string
        // In that case, we want to say the date is invalid
        if (typeof date === 'string') {
            return false;
        }
        // Length of months (will update for leap years)
        const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        const { month, year, day } = date;
        // Make sure date is in range
        if (year < 2000 || year > 3000 || month === 0 || month > 12) {
            return false;
        }
        // Adjust for leap years
        if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
            monthLength[1] = 29;
        }
        // Check range of the month
        if (month <= 0 || month > 12) {
            return false;
        }
        // Check the range of the day
        if (day < 0 || day > monthLength[month - 1]) {
            return false;
        }
        return true;
    }
}
UkVatDateValidatorService.ɵfac = function UkVatDateValidatorService_Factory(t) { return new (t || UkVatDateValidatorService)(ɵngcc0.ɵɵinject(UkVatPeriodsUtilsService)); };
UkVatDateValidatorService.ɵprov = i0.ɵɵdefineInjectable({ factory: function UkVatDateValidatorService_Factory() { return new UkVatDateValidatorService(i0.ɵɵinject(UkVatPeriodsUtilsService)); }, token: UkVatDateValidatorService, providedIn: "root" });
UkVatDateValidatorService.ctorParameters = () => [
    { type: UkVatPeriodsUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkVatDateValidatorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: UkVatPeriodsUtilsService }]; }, null); })();

class UkVatPeriodsAddPeriodComponent {
    constructor(alertService, ukVatPeriodService, utilsService, activeModal, dateValidatorService) {
        this.alertService = alertService;
        this.ukVatPeriodService = ukVatPeriodService;
        this.utilsService = utilsService;
        this.activeModal = activeModal;
        this.dateValidatorService = dateValidatorService;
        this.newPeriod = new EventEmitter();
        this.alerts = [];
        this.subscription$ = new Subscription();
        this.dateConfig = { type: 'recent', format: 'dd/mm/yyyy' };
    }
    ngOnInit() {
        // subscribe to alerts service ahead, following async actions can eventualy push alert
        this.subscription$.add(this.alertService.onAlertAdded.subscribe((alert) => this.alerts.push(alert)));
        this.subscription$.add(this.alertService.clearAll.subscribe(() => (this.alerts = [])));
    }
    ngOnDestroy() {
        this.alertService.clearAll.emit();
        this.subscription$.unsubscribe();
    }
    onAdd() {
        const startDate = this.utilsService.ngbDateStructToDate(this.periodStartDate);
        const endDate = this.utilsService.ngbDateStructToDate(this.periodEndDate);
        this.ukVatPeriodService.addNewProvisionalPeriod(this.contactId, startDate, endDate).then(periods => {
            this.newPeriod.emit(periods[0]);
            this.onClose();
        }, () => {
            this.alertService.addDangerAlert('Provisional period failed to save, try again.');
        });
    }
    /**
     * Handles modal close without saving changes
     */
    onClose() {
        this.activeModal.close();
    }
    /**
     * Handles modal close without saving changes
     */
    onCancel() {
        this.activeModal.dismiss();
    }
    /**
     * Closes the HTML DatePicker if it necessary, validates the date and tells the parent whether or not its valid
     * @param datePicker- NgbDatePicker element ref from the HTML
     */
    onValueApply(datePicker, isStartDate) {
        if (datePicker) {
            datePicker.close();
        }
        if (isStartDate) {
            this.invalidStartDateError = this.dateValidatorService.validatePeriodDate(this.periodStartDate, this.periodEndDate, isStartDate);
            this.invalidEndDateError = this.dateValidatorService.syncPeriodValidation(this.invalidStartDateError, this.invalidEndDateError);
        }
        else {
            this.invalidEndDateError = this.dateValidatorService.validatePeriodDate(this.periodStartDate, this.periodEndDate);
            this.invalidStartDateError = this.dateValidatorService.syncPeriodValidation(this.invalidEndDateError, this.invalidStartDateError);
        }
    }
}
UkVatPeriodsAddPeriodComponent.ɵfac = function UkVatPeriodsAddPeriodComponent_Factory(t) { return new (t || UkVatPeriodsAddPeriodComponent)(ɵngcc0.ɵɵdirectiveInject(UkVatAlertService), ɵngcc0.ɵɵdirectiveInject(UkVatPeriodsService), ɵngcc0.ɵɵdirectiveInject(UkVatPeriodsUtilsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(UkVatDateValidatorService)); };
UkVatPeriodsAddPeriodComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UkVatPeriodsAddPeriodComponent, selectors: [["uk-vat-periods-add-period"]], inputs: { contactId: "contactId" }, outputs: { newPeriod: "newPeriod" }, decls: 38, vars: 18, consts: [[3, "items"], [1, "modal-header"], ["id", "modal-basic-title", 1, "modal-title"], ["type", "button", "aria-label", "Close", "data-qe-id", "ukVat.addPeriodModal.cancelCrossButton", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body", "uk-vat-add-period-modal-body"], ["name", "form", "novalidate", ""], [1, "form-group", "mb-3", "bmpp-uk-vat-periods-control", 3, "ngClass"], [1, "bento-label-required", "m-0"], [1, "form-text", "text-muted", "mb-1", "mt-0"], ["id", "periodStartDateCtrl", "name", "periodStartDateCtrl", "ngbDatepicker", "", "data-qe-id", "ukVat.addPeriodModal.addPeriodStartDate.datePickerInput", 1, "form-control", "bento-datepicker", 3, "ngModel", "firstDayOfWeek", "bentoDatepickerConfig", "ngModelChange", "blur", "closed"], ["startDatePickerInput", "ngbDatepicker", "periodStartDateCtrl", "ngModel"], ["type", "button", "aria-haspopup", "true", "aria-label", "Open calendar", "title", "Open calendar", "data-qe-id", "ukVat.addPeriodModal.addPeriodStartDate.datePickerOpenCalendarButton", 1, "btn", "btn-outline-primary", "btn-icon", "ml-2", 3, "bentoDatepickerToggle"], ["aria-hidden", "true", 1, "bento-icon-calendar"], ["class", "bmpp-validation-message mt-1", 4, "ngIf"], [1, "form-group", "bmpp-uk-vat-periods-control", 3, "ngClass"], ["id", "periodEndDateCtrl", "name", "periodEndDateCtrl", "ngbDatepicker", "", "data-qe-id", "ukVat.addPeriodModal.addPeriodEndDate.datePickerInput", 1, "form-control", "bento-datepicker", 3, "ngModel", "firstDayOfWeek", "bentoDatepickerConfig", "ngModelChange", "blur", "closed"], ["endDatePickerInput", "ngbDatepicker", "periodEndDateCtrl", "ngModel"], ["type", "button", "aria-haspopup", "true", "aria-label", "Open calendar", "title", "Open calendar", "data-qe-id", "ukVat.addPeriodModal.addPeriodEndDate.datePickerOpenCalendarButton", 1, "btn", "btn-outline-primary", "btn-icon", "ml-2", 3, "bentoDatepickerToggle"], [1, "modal-footer"], ["type", "button", "data-qe-id", "ukVat.addPeriodModal.addButton", 1, "btn", "btn-primary", 3, "disabled", "click"], ["type", "button", "data-qe-id", "ukVat.addPeriodModal.cancelButton", 1, "btn", "btn-outline-dark", "btn-outline-primary", 3, "click"], [1, "bmpp-validation-message", "mt-1"], [1, "bento-icon-warning-filled"], ["role", "alert", 4, "ngIf"], ["role", "alert"]], template: function UkVatPeriodsAddPeriodComponent_Template(rf, ctx) { if (rf & 1) {
        const _r12 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelement(0, "bento-alert", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1)(2, "h2", 2);
        ɵngcc0.ɵɵtext(3, "Add provisional period");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "button", 3);
        ɵngcc0.ɵɵlistener("click", function UkVatPeriodsAddPeriodComponent_Template_button_click_4_listener() { return ctx.onClose(); });
        ɵngcc0.ɵɵelementStart(5, "span", 4);
        ɵngcc0.ɵɵtext(6, "\u00D7");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(7, "div", 5)(8, "form", 6)(9, "div", 7)(10, "label", 8);
        ɵngcc0.ɵɵtext(11, "Period start date");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "p", 9);
        ɵngcc0.ɵɵtext(13, "DD/MM/YYYY");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "input", 10, 11);
        ɵngcc0.ɵɵlistener("ngModelChange", function UkVatPeriodsAddPeriodComponent_Template_input_ngModelChange_14_listener($event) { return ctx.periodStartDate = $event; })("blur", function UkVatPeriodsAddPeriodComponent_Template_input_blur_14_listener() { ɵngcc0.ɵɵrestoreView(_r12); const _r0 = ɵngcc0.ɵɵreference(15); return ctx.onValueApply(_r0, true); })("closed", function UkVatPeriodsAddPeriodComponent_Template_input_closed_14_listener() { return ctx.onValueApply(null, true); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "button", 12);
        ɵngcc0.ɵɵelement(18, "i", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(19, UkVatPeriodsAddPeriodComponent_div_19_Template, 5, 3, "div", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 15)(21, "label", 8);
        ɵngcc0.ɵɵtext(22, "Period end date");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "p", 9);
        ɵngcc0.ɵɵtext(24, "DD/MM/YYYY");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "input", 16, 17);
        ɵngcc0.ɵɵlistener("ngModelChange", function UkVatPeriodsAddPeriodComponent_Template_input_ngModelChange_25_listener($event) { return ctx.periodEndDate = $event; })("blur", function UkVatPeriodsAddPeriodComponent_Template_input_blur_25_listener() { ɵngcc0.ɵɵrestoreView(_r12); const _r3 = ɵngcc0.ɵɵreference(26); return ctx.onValueApply(_r3); })("closed", function UkVatPeriodsAddPeriodComponent_Template_input_closed_25_listener() { return ctx.onValueApply(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "button", 18);
        ɵngcc0.ɵɵelement(29, "i", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(30, UkVatPeriodsAddPeriodComponent_div_30_Template, 5, 3, "div", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "p");
        ɵngcc0.ɵɵtext(32, "* Required fields");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(33, "div", 19)(34, "button", 20);
        ɵngcc0.ɵɵlistener("click", function UkVatPeriodsAddPeriodComponent_Template_button_click_34_listener() { return ctx.onAdd(); });
        ɵngcc0.ɵɵtext(35, " Add ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "button", 21);
        ɵngcc0.ɵɵlistener("click", function UkVatPeriodsAddPeriodComponent_Template_button_click_36_listener() { return ctx.onCancel(); });
        ɵngcc0.ɵɵtext(37, " Cancel ");
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(15);
        const _r3 = ɵngcc0.ɵɵreference(26);
        ɵngcc0.ɵɵproperty("items", ctx.alerts);
        ɵngcc0.ɵɵadvance(9);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(14, _c0, ctx.invalidStartDateError));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.periodStartDate)("firstDayOfWeek", 7)("bentoDatepickerConfig", ctx.dateConfig);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("bentoDatepickerToggle", _r0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.invalidStartDateError);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(16, _c0, ctx.invalidEndDateError));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.periodEndDate)("firstDayOfWeek", 7)("bentoDatepickerConfig", ctx.dateConfig);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("bentoDatepickerToggle", _r3);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.invalidEndDateError);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("disabled", ctx.invalidEndDateError || ctx.invalidStartDateError || !ctx.periodStartDate || !ctx.periodEndDate);
    } }, directives: [ɵngcc4.BentoAlertComponent, ɵngcc4.BentoFocusMonitorDirective, ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, ɵngcc6.NgClass, ɵngcc3.NgbInputDatepicker, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc4.BentoDatepickerConfigDirective, ɵngcc4.BentoDatepickerToggleDirective, ɵngcc6.NgIf, ɵngcc4.BentoFooterTabHelper], styles: [".uk-vat-add-period-modal-body label.bento-label-required:after{font-size:inherit}.uk-vat-add-period-form-control .form-control.bento-datepicker{border-color:#dc0a0a}.uk-vat-add-period-modal-body input.ng-dirty.ng-invalid{color:#000!important}.bmpp-uk-vat-periods-control>.form-control{display:inline-block;float:none;height:30px;width:150px;border-radius:0}#bentoNGModalContainer .uk-vat-periods-add-period .modal-content .modal-footer .btn{margin:.25rem!important}#bentoNGModalContainer .uk-vat-periods-add-period ngb-datepicker .ngb-dp-day.hidden{display:block!important}#bentoNGModalContainer .uk-vat-periods-add-period .bmpp-validation-message{color:#dc0a0a!important}#bentoNGModalContainer .uk-vat-periods-add-period .bmpp-validation-message i{float:left;margin-right:6px;font-size:15px}"], encapsulation: 2 });
UkVatPeriodsAddPeriodComponent.ctorParameters = () => [
    { type: UkVatAlertService },
    { type: UkVatPeriodsService },
    { type: UkVatPeriodsUtilsService },
    { type: NgbActiveModal },
    { type: UkVatDateValidatorService }
];
UkVatPeriodsAddPeriodComponent.propDecorators = {
    contactId: [{ type: Input }],
    newPeriod: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkVatPeriodsAddPeriodComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line: component-selector
                selector: 'uk-vat-periods-add-period',
                template: "<bento-alert [items]=\"alerts\"></bento-alert>\n<div class=\"modal-header\">\n  <h2 class=\"modal-title\" id=\"modal-basic-title\">Add provisional period</h2>\n  <button\n    type=\"button\"\n    class=\"close\"\n    aria-label=\"Close\"\n    data-qe-id=\"ukVat.addPeriodModal.cancelCrossButton\"\n    (click)=\"onClose()\"\n  >\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body uk-vat-add-period-modal-body\">\n  <form name=\"form\" novalidate>\n    <div class=\"form-group mb-3 bmpp-uk-vat-periods-control\"\n      [ngClass]=\"{'uk-vat-add-period-form-control': invalidStartDateError}\">\n      <label class=\"bento-label-required m-0\">Period start date</label>\n      <p class=\"form-text text-muted mb-1 mt-0\">DD/MM/YYYY</p>\n      <input\n        class=\"form-control bento-datepicker\"\n        id=\"periodStartDateCtrl\"\n        name=\"periodStartDateCtrl\"\n        ngbDatepicker\n        #startDatePickerInput=\"ngbDatepicker\"\n        [(ngModel)]=\"periodStartDate\"\n        #periodStartDateCtrl=\"ngModel\"\n        [firstDayOfWeek]=\"7\"\n        [bentoDatepickerConfig]=\"dateConfig\"\n        data-qe-id=\"ukVat.addPeriodModal.addPeriodStartDate.datePickerInput\"\n        (blur)=\"onValueApply(startDatePickerInput, true)\"\n        (closed)=\"onValueApply(null, true)\"\n      />\n      <button\n        class=\"btn btn-outline-primary btn-icon ml-2\"\n        [bentoDatepickerToggle]=\"startDatePickerInput\"\n        type=\"button\"\n        aria-haspopup=\"true\"\n        aria-label=\"Open calendar\"\n        title=\"Open calendar\"\n        data-qe-id=\"ukVat.addPeriodModal.addPeriodStartDate.datePickerOpenCalendarButton\"\n      >\n        <i class=\"bento-icon-calendar\" aria-hidden=\"true\"></i>\n      </button>\n      \n      <div class=\"bmpp-validation-message mt-1\" *ngIf=\"invalidStartDateError\">\n        <i class=\"bento-icon-warning-filled\"></i>\n        <span role=\"alert\" *ngIf=\"invalidStartDateError === 'required'\">Period start date is required</span>\n        <span role=\"alert\" *ngIf=\"invalidStartDateError === 'invalidFormat'\"\n          >Enter the Period start date as dd/mm/yyyy</span\n        >\n        <span role=\"alert\" *ngIf=\"invalidStartDateError === 'endMustBeLaterThanStart' \"\n          >The period end date must be later than the period start date</span\n        >\n      </div>\n    </div>\n    <div class=\"form-group bmpp-uk-vat-periods-control\"\n      [ngClass]=\"{'uk-vat-add-period-form-control': invalidEndDateError}\">\n      <label class=\"bento-label-required m-0\">Period end date</label>\n      <p class=\"form-text text-muted mb-1 mt-0\">DD/MM/YYYY</p>\n      <input\n        class=\"form-control bento-datepicker\"\n        id=\"periodEndDateCtrl\"\n        name=\"periodEndDateCtrl\"\n        ngbDatepicker\n        #endDatePickerInput=\"ngbDatepicker\"\n        [(ngModel)]=\"periodEndDate\"\n        #periodEndDateCtrl=\"ngModel\"\n        [firstDayOfWeek]=\"7\"\n        [bentoDatepickerConfig]=\"dateConfig\"\n        data-qe-id=\"ukVat.addPeriodModal.addPeriodEndDate.datePickerInput\"\n        (blur)=\"onValueApply(endDatePickerInput)\"\n        (closed)=\"onValueApply()\"\n      />\n      <button\n        class=\"btn btn-outline-primary btn-icon ml-2\"\n        type=\"button\"\n        [bentoDatepickerToggle]=\"endDatePickerInput\"\n        aria-haspopup=\"true\"\n        aria-label=\"Open calendar\"\n        title=\"Open calendar\"\n        data-qe-id=\"ukVat.addPeriodModal.addPeriodEndDate.datePickerOpenCalendarButton\"\n      >\n        <i class=\"bento-icon-calendar\" aria-hidden=\"true\"></i>\n      </button>\n      <div class=\"bmpp-validation-message mt-1\" *ngIf=\"invalidEndDateError\">\n        <i class=\"bento-icon-warning-filled\"></i>\n        <span role=\"alert\" *ngIf=\"invalidEndDateError === 'required'\">Period end date is required</span>\n        <span role=\"alert\" *ngIf=\"invalidEndDateError === 'invalidFormat'\">Enter the Period end date as dd/mm/yyyy</span>\n        <span role=\"alert\" *ngIf=\"invalidEndDateError === 'endMustBeLaterThanStart'\"\n          >The period end date must be later than the period start date</span\n        >\n      </div>\n    </div>\n    <p>* Required fields</p>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button\n    type=\"button\"\n    class=\"btn btn-primary\"\n    (click)=\"onAdd()\"\n    [disabled]=\"invalidEndDateError || invalidStartDateError || !periodStartDate || !periodEndDate\"\n    data-qe-id=\"ukVat.addPeriodModal.addButton\"\n  >\n    Add\n  </button>\n  <button\n    type=\"button\"\n    class=\"btn btn-outline-dark btn-outline-primary\"\n    data-qe-id=\"ukVat.addPeriodModal.cancelButton\"\n    (click)=\"onCancel()\"\n  >\n    Cancel\n  </button>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".uk-vat-add-period-modal-body label.bento-label-required:after{font-size:inherit}.uk-vat-add-period-form-control .form-control.bento-datepicker{border-color:#dc0a0a}.uk-vat-add-period-modal-body input.ng-dirty.ng-invalid{color:#000!important}.bmpp-uk-vat-periods-control>.form-control{display:inline-block;float:none;height:30px;width:150px;border-radius:0}#bentoNGModalContainer .uk-vat-periods-add-period .modal-content .modal-footer .btn{margin:.25rem!important}#bentoNGModalContainer .uk-vat-periods-add-period ngb-datepicker .ngb-dp-day.hidden{display:block!important}#bentoNGModalContainer .uk-vat-periods-add-period .bmpp-validation-message{color:#dc0a0a!important}#bentoNGModalContainer .uk-vat-periods-add-period .bmpp-validation-message i{float:left;margin-right:6px;font-size:15px}"]
            }]
    }], function () { return [{ type: UkVatAlertService }, { type: UkVatPeriodsService }, { type: UkVatPeriodsUtilsService }, { type: ɵngcc3.NgbActiveModal }, { type: UkVatDateValidatorService }]; }, { newPeriod: [{
            type: Output
        }], contactId: [{
            type: Input
        }] }); })();

class UkVatPeriodsComponent {
    constructor(modalService, ukVatPeriodsService) {
        this.modalService = modalService;
        this.ukVatPeriodsService = ukVatPeriodsService;
        this.vatNumber = null;
        this.alerts = [];
    }
    ngOnInit() {
        this.hasPermission = true;
        this.setDefaults();
        this.getHasPermission();
    }
    ngOnChanges(changes) {
        var _a;
        if ((_a = changes === null || changes === void 0 ? void 0 : changes.contactId) === null || _a === void 0 ? void 0 : _a.currentValue) {
            this.setDefaults();
            this.contactId = changes.contactId.currentValue;
            this.getVatData();
        }
    }
    /**
     * Navigation to General tab click handler
     */
    navigateToGeneral() {
        const liTabs = document.querySelectorAll('li[data-qe-id]');
        liTabs.forEach((li) => {
            if (li.getAttribute('data-qe-id') === 'tab-general') {
                li.firstElementChild.click();
            }
        });
    }
    /**
     * Check if there are unavailable periods
     */
    hasUnavailablePeriods() {
        return this.periods.some((period) => !period.periodKey || period.periodKey === '');
    }
    /**
     * Check if there are unavailable periods
     */
    hasOpenPeriods() {
        return this.periods.some((period) => (period === null || period === void 0 ? void 0 : period.status) === 'O');
    }
    /**
     * Create no permission messsage
     */
    noPermissionMessage() {
        const middleMessage = this.hasPeriods()
            ? 'for Onvio to interact with HMRC so VAT periods may not be up to date.'
            : 'to retrieve VAT periods from HMRC.';
        const message = `You do not have the required permissions ${middleMessage} Please refer to your firm administrator.`;
        return message;
    }
    /**
     * Check if userMessages exist
     */
    showUserMessages() {
        var _a;
        return Boolean((_a = this.userMessages) === null || _a === void 0 ? void 0 : _a.length);
    }
    /**
     * Check if periods exist
     */
    hasPeriods() {
        var _a;
        return Boolean((_a = this.periods) === null || _a === void 0 ? void 0 : _a.length);
    }
    /**
     * Check if new period can be added
     */
    showAddPeriod() {
        // we want to show the add period UI if we have no periods
        return (Boolean(this.contactId) &&
            !this.hasPeriods() &&
            !this.isLoading &&
            !this.isSyncing &&
            (!this.loadingError || this.hadSyncingError || !this.vatNumber));
    }
    /**
     * Open Add provisional period
     */
    onAddPeriod() {
        const options = {
            backdrop: 'static',
            ariaLabelledBy: 'modal-basic-title',
            container: '#bentoNGModalContainer',
            windowClass: 'uk-vat-periods-add-period',
        };
        const modalRef = this.modalService.open(UkVatPeriodsAddPeriodComponent, options);
        modalRef.componentInstance.contactId = this.contactId;
        modalRef.componentInstance.newPeriod.subscribe($period => {
            this.periods.push($period);
        });
    }
    /**
     * Get HMRC api permission
     */
    getHasPermission() {
        return __awaiter(this, void 0, void 0, function* () {
            this.hasPermission = yield has('UKVAT.HMRCAPIAccess');
        });
    }
    /**
     * Show response error
     * @param error - response error
     */
    onLoadError(error) {
        this.isLoading = false;
        this.isSyncing = false;
        const prefix = this.noSync ? 'Error loading VAT periods' : 'Error syncing VAT periods with HMRC';
        this.loadingError = prefix + (error.message ? `: ${error.message}` : '');
    }
    /**
     * Complete request handler
     * @param success - success response option
     */
    onCompletion() {
        this.isLoading = false;
        this.isSyncing = false;
    }
    /**
     * Get information for VAT Tax panel
     */
    getVatData() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isLoading = true;
            this.isSyncing = !this.noSync;
            this.loadingError = null;
            this.hadSyncingError = false;
            try {
                this.isVatApplicable = yield this.ukVatPeriodsService.getShowVatTabByContactId(this.contactId);
                if (this.isVatApplicable) {
                    yield this.getVatNumber();
                }
                else {
                    this.onCompletion();
                }
            }
            catch (err) {
                this.onLoadError(err);
            }
        });
    }
    /**
     * Get VAT number
     */
    getVatNumber() {
        return __awaiter(this, void 0, void 0, function* () {
            let sync = !this.noSync;
            const emptyAlert = {
                type: 'warning',
                closeable: true,
                template: this.emptyTemplate,
            };
            try {
                const vatNumber = yield this.ukVatPeriodsService.getVatNumberByContactId(this.contactId);
                this.vatNumber = vatNumber;
                if (!vatNumber) {
                    this.alerts = [emptyAlert];
                    // we won't be able to sync, so just do a load
                    sync = false;
                }
                this.getPeriods(sync);
            }
            catch (error) {
                console.log('Had error getting VAT number for contact', error);
                this.alerts = [emptyAlert];
                // we won't be able to sync, so just do a load
                this.hadSyncingError = sync;
                this.getPeriods(false);
            }
        });
    }
    /**
     * Get contact periods list
     * @param sync - syncing option
     */
    getPeriods(sync) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.isLoading = true;
            this.isSyncing = sync;
            try {
                const vatPeriodsResponse = yield this.ukVatPeriodsService.getVatPeriodsByContactId(this.contactId, sync);
                this.periods = vatPeriodsResponse.periods;
                this.userMessages = vatPeriodsResponse.userMessages;
                if (!this.hadSyncingError && (!((_a = this.periods) === null || _a === void 0 ? void 0 : _a.length) || !this.hasOpenPeriods())) {
                    const alert = {
                        type: 'info',
                        closeable: true,
                        msg: 'HMRC does not have any open periods for this VAT number.',
                    };
                    this.alerts = [alert];
                }
                this.onCompletion();
            }
            catch (error) {
                this.showSyncAlert(error);
                this.onCompletion();
                if (sync) {
                    this.hadSyncingError = true;
                    this.getPeriods(false);
                }
            }
        });
    }
    showSyncAlert(httpError) {
        var _a, _b, _c, _d;
        if (((_b = (_a = httpError.error) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.message) === 'The client and/or agent is not authorised.') {
            const alert = {
                type: 'warning',
                closeable: true,
                msg: 'The client and/or agent is not authorised. This caused a sync error with HMRC and the subsequent failure to return VAT periods.',
            };
            this.alerts = [alert];
        }
        else if (((_d = (_c = httpError.error) === null || _c === void 0 ? void 0 : _c.error) === null || _d === void 0 ? void 0 : _d.message) === 'The VAT Registration Number VRN is not valid') {
            const invalidAlert = {
                type: 'warning',
                closeable: true,
                template: this.invalidTemplate,
            };
            this.alerts = [invalidAlert];
        }
    }
    setDefaults() {
        this.alerts = [];
        this.vatNumber = null;
        this.periods = [];
        this.isLoading = false;
        this.loadingError = null;
        this.isSyncing = false;
        this.hadSyncingError = false;
        this.isVatApplicable = false;
        this.userMessages = [];
    }
}
UkVatPeriodsComponent.ɵfac = function UkVatPeriodsComponent_Factory(t) { return new (t || UkVatPeriodsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbModal), ɵngcc0.ɵɵdirectiveInject(UkVatPeriodsService)); };
UkVatPeriodsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UkVatPeriodsComponent, selectors: [["uk-vat-periods-ng"]], viewQuery: function UkVatPeriodsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c1, 7);
        ɵngcc0.ɵɵviewQuery(_c2, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.emptyTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.invalidTemplate = _t.first);
    } }, inputs: { contactId: "contactId", noSync: "noSync" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 5, vars: 1, consts: [[4, "ngIf"], ["emptyVatNumberAlertTemplate", ""], ["invalidVatNumberAlertTemplate", ""], ["class", "vat-tab-content", 4, "ngIf"], [1, "vat-tab-content"], [3, "vatNumber"], [1, "row", 3, "bentoBusyLoader", "size"], ["class", "col-lg-6 vat-mt-10", 4, "ngIf"], ["class", "col-lg-12 vat-mb-16 vat-mt-10", 4, "ngIf"], ["class", "col-lg-12 vat-mb-16", 4, "ngIf"], ["class", "col-lg-12", 3, "vat-mt-10", 4, "ngIf"], ["class", "busyloader-text-content", 4, "ngIf"], [1, "col-lg-6", "vat-mt-10"], [3, "inline", "items"], [1, "error", "text-danger"], [3, "userMessages"], [1, "col-lg-12", "vat-mb-16", "vat-mt-10"], [1, "col-lg-12", "vat-mb-16"], [1, "vat-mb-16", "vat-mt-10"], ["data-qe-id", "ukVatPeriod.addPeriodButton", 1, "btn", "btn-link", "btn-icon", "add-period-link", 3, "click"], [1, "bento-icon-add-filled", 2, "margin-right", "0.5em"], [1, "col-lg-12"], [3, "periods"], [1, "busyloader-text-content"], [1, "position-relative", "h-100"], [1, "busyloader-text"], ["data-qe-id", "bmpp.vatPeriods.emptyVatNumberAlert.generalTabHyperlink", 1, "general-tab-link", 3, "click"], ["data-qe-id", "bmpp.vatPeriods.invalidVatNumberAlert.generalTabHyperlink", 1, "general-tab-link", 3, "click"]], template: function UkVatPeriodsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, UkVatPeriodsComponent_div_0_Template, 3, 2, "div", 0);
        ɵngcc0.ɵɵtemplate(1, UkVatPeriodsComponent_ng_template_1_Template, 5, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, UkVatPeriodsComponent_ng_template_3_Template, 5, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isVatApplicable);
    } }, directives: function () { return [ɵngcc6.NgIf, UkVatPeriodsVatNumberComponent, ɵngcc4.BentoBusyLoaderDirective, ɵngcc4.BentoAlertComponent, UkVatPeriodsUserMessagesComponent, ɵngcc4.BentoFocusMonitorDirective, UkVatPeriodsTableComponent]; }, styles: [".general-tab-link[_ngcontent-%COMP%]{color:#404040;text-decoration:underline}.general-tab-link[_ngcontent-%COMP%]:hover{cursor:pointer;text-decoration:underline}.vat-mt-10[_ngcontent-%COMP%]{margin-top:10px}.vat-mb-16[_ngcontent-%COMP%]{margin-bottom:16px}.vat-sync-content[_ngcontent-%COMP%]{min-height:150px;position:relative}[_nghost-%COMP%]     .vat-tab-content .alert{margin-bottom:6px!important}[_nghost-%COMP%]     .vat-tab-content .btn.add-period-link{padding-left:.5rem!important}.busyloader-text-content[_ngcontent-%COMP%]{height:100%;position:absolute;min-height:50px;text-align:center;width:100%;z-index:2002}.busyloader-text[_ngcontent-%COMP%]{position:absolute;top:50%;transform:translate(-50%,50px)}"] });
UkVatPeriodsComponent.ctorParameters = () => [
    { type: NgbModal },
    { type: UkVatPeriodsService }
];
UkVatPeriodsComponent.propDecorators = {
    contactId: [{ type: Input }],
    noSync: [{ type: Input }],
    emptyTemplate: [{ type: ViewChild, args: ['emptyVatNumberAlertTemplate', { static: true },] }],
    invalidTemplate: [{ type: ViewChild, args: ['invalidVatNumberAlertTemplate', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkVatPeriodsComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line: component-selector
                selector: 'uk-vat-periods-ng',
                template: "<div *ngIf=\"isVatApplicable\">\n  <div *ngIf=\"!hasPermission\">{{ noPermissionMessage() }}</div>\n  <div class=\"vat-tab-content\" *ngIf=\"hasPermission\">\n    <uk-vat-periods-vat-number [vatNumber]=\"vatNumber\"></uk-vat-periods-vat-number>\n    <div\n      class=\"row\"\n      [class.vat-sync-content]=\"isLoading || isSyncing\"\n      [bentoBusyLoader]=\"isLoading || isSyncing\"\n      [size]=\"'lg'\"\n    >\n      <div class=\"col-lg-6 vat-mt-10\" *ngIf=\"alerts.length || userMessages?.length || loadingError\">\n        <bento-alert [inline]=\"true\" [items]=\"alerts\"></bento-alert>\n        <div *ngIf=\"loadingError\">\n          <div class=\"error text-danger\">{{ loadingError }}</div>\n          <br />\n        </div>\n        <div *ngIf=\"userMessages?.length\">\n          <uk-vat-periods-user-messages [userMessages]=\"userMessages\"></uk-vat-periods-user-messages>\n        </div>\n      </div>\n      <div\n        class=\"col-lg-12 vat-mb-16 vat-mt-10\"\n        *ngIf=\"hasUnavailablePeriods() || (!hasUnavailablePeriods() && hasOpenPeriods())\"\n      >\n        <div *ngIf=\"hasUnavailablePeriods()\">\n          VAT periods have been created but are not yet available on HMRC. The status will be automatically updated when they\n          become available.\n          <br />\n        </div>\n        <div *ngIf=\"!hasUnavailablePeriods() && hasOpenPeriods()\">\n          The following open periods are available in HMRC.\n          <br />\n        </div>\n      </div>\n      <div class=\"col-lg-12 vat-mb-16\" *ngIf=\"showAddPeriod()\">\n        <p class=\"vat-mb-16 vat-mt-10\">\n          You can create an initial provisional VAT period that will have an HMRC status of \"Not Available\" until the period\n          is synchronised successfully.\n        </p>\n        <button class=\"btn btn-link btn-icon add-period-link\" data-qe-id=\"ukVatPeriod.addPeriodButton\" (click)=\"onAddPeriod()\">\n          <i class=\"bento-icon-add-filled\" style=\"margin-right: 0.5em\" ></i>\n          Add provisional period\n        </button>\n      </div>\n      <div *ngIf=\"hasPeriods()\" class=\"col-lg-12\" [class.vat-mt-10]=\"!(hasUnavailablePeriods() || (!hasUnavailablePeriods() && hasOpenPeriods()))\">\n        <uk-vat-periods-table [periods]=\"periods\"></uk-vat-periods-table>\n      </div>\n      <div class=\"busyloader-text-content\" *ngIf=\"isLoading || isSyncing\">\n        <div class=\"position-relative h-100\">\n          <span class=\"busyloader-text\">Attempting to sync VAT periods with HMRC</span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<ng-template #emptyVatNumberAlertTemplate let-options=\"options\" let-index=\"index\">\n  <div>\n    A VAT number has not been provided for the contact. Add it in the\n    <a\n      class=\"general-tab-link\"\n      data-qe-id=\"bmpp.vatPeriods.emptyVatNumberAlert.generalTabHyperlink\"\n      (click)=\"navigateToGeneral()\"\n      >General tab</a\n    >.\n  </div>\n</ng-template>\n<ng-template #invalidVatNumberAlertTemplate let-options=\"options\" let-index=\"index\">\n  <div>\n    The VAT Number is invalid. Enter a valid VAT Number in the\n    <a\n      class=\"general-tab-link\"\n      data-qe-id=\"bmpp.vatPeriods.invalidVatNumberAlert.generalTabHyperlink\"\n      (click)=\"navigateToGeneral()\"\n      >General tab</a\n    >.\n  </div>\n</ng-template>\n",
                styles: [".general-tab-link{color:#404040;text-decoration:underline}.general-tab-link:hover{cursor:pointer;text-decoration:underline}.vat-mt-10{margin-top:10px}.vat-mb-16{margin-bottom:16px}.vat-sync-content{min-height:150px;position:relative}:host ::ng-deep .vat-tab-content .alert{margin-bottom:6px!important}:host ::ng-deep .vat-tab-content .btn.add-period-link{padding-left:.5rem!important}.busyloader-text-content{height:100%;position:absolute;min-height:50px;text-align:center;width:100%;z-index:2002}.busyloader-text{position:absolute;top:50%;transform:translate(-50%,50px)}"]
            }]
    }], function () { return [{ type: ɵngcc3.NgbModal }, { type: UkVatPeriodsService }]; }, { contactId: [{
            type: Input
        }], noSync: [{
            type: Input
        }], emptyTemplate: [{
            type: ViewChild,
            args: ['emptyVatNumberAlertTemplate', { static: true }]
        }], invalidTemplate: [{
            type: ViewChild,
            args: ['invalidVatNumberAlertTemplate', { static: true }]
        }] }); })();

class UkVatPeriodsTableComponent {
    get sortedPeriods() {
        // sort periods latest first
        return this.periods.sort((p1, p2) => (p1.start < p2.start ? 1 : p1.start === p2.start ? 0 : -1));
    }
}
UkVatPeriodsTableComponent.ɵfac = function UkVatPeriodsTableComponent_Factory(t) { return new (t || UkVatPeriodsTableComponent)(); };
UkVatPeriodsTableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UkVatPeriodsTableComponent, selectors: [["uk-vat-periods-table"]], inputs: { periods: "periods" }, decls: 12, vars: 1, consts: [[1, "uk-vat-table-container", "col-xs-12", "col-md-9", "col-lg-6"], [1, "table"], ["scope", "col"], [4, "ngFor", "ngForOf"], [3, "period"]], template: function UkVatPeriodsTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "table", 1)(2, "thead")(3, "tr")(4, "th", 2);
        ɵngcc0.ɵɵtext(5, "Period start date");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "th", 2);
        ɵngcc0.ɵɵtext(7, "Period end date");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "th", 2);
        ɵngcc0.ɵɵtext(9, "HMRC status");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(10, "tbody");
        ɵngcc0.ɵɵtemplate(11, UkVatPeriodsTableComponent_tr_11_Template, 9, 9, "tr", 3);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(11);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.sortedPeriods);
    } }, directives: function () { return [ɵngcc6.NgForOf, UkVatPeriodsStatusDisplayComponent]; }, pipes: function () { return [ɵngcc6.DatePipe]; }, styles: [".uk-vat-table-container[_ngcontent-%COMP%]{padding-left:0}.uk-vat-table-container[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > td[_ngcontent-%COMP%], .uk-vat-table-container[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > th[_ngcontent-%COMP%]{border:1px solid #d0d0d0}"] });
UkVatPeriodsTableComponent.propDecorators = {
    periods: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkVatPeriodsTableComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line: component-selector
                selector: 'uk-vat-periods-table',
                template: "<div class=\"uk-vat-table-container col-xs-12 col-md-9 col-lg-6\">\n  <table class=\"table\">\n    <thead>\n      <tr>\n        <th scope=\"col\">Period start date</th>\n        <th scope=\"col\">Period end date</th>\n        <th scope=\"col\">HMRC status</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr *ngFor=\"let period of sortedPeriods\">\n        <td>{{ period.start | date: 'dd/MM/yyyy' }}</td>\n        <td>{{ period.end | date: 'dd/MM/yyyy' }}</td>\n        <td><uk-vat-period-status-display [period]=\"period\"></uk-vat-period-status-display></td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n",
                styles: [".uk-vat-table-container{padding-left:0}.uk-vat-table-container tbody>tr>td,.uk-vat-table-container thead>tr>th{border:1px solid #d0d0d0}"]
            }]
    }], null, { periods: [{
            type: Input
        }] }); })();

class UkVatPeriodsStatusDisplayComponent {
    formatPeriodStatus() {
        if (!this.period) {
            return '';
        }
        if (!this.period.periodKey || this.period.periodKey === '') {
            return 'Not Available';
        }
        if (this.period.status === 'O') {
            return 'Open';
        }
        if (this.period.status === 'F') {
            return 'Fulfilled';
        }
        return this.period.status;
    }
}
UkVatPeriodsStatusDisplayComponent.ɵfac = function UkVatPeriodsStatusDisplayComponent_Factory(t) { return new (t || UkVatPeriodsStatusDisplayComponent)(); };
UkVatPeriodsStatusDisplayComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UkVatPeriodsStatusDisplayComponent, selectors: [["uk-vat-period-status-display"]], inputs: { period: "period" }, decls: 1, vars: 1, template: function UkVatPeriodsStatusDisplayComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0);
    } if (rf & 2) {
        ɵngcc0.ɵɵtextInterpolate(ctx.formatPeriodStatus());
    } }, encapsulation: 2 });
UkVatPeriodsStatusDisplayComponent.propDecorators = {
    period: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkVatPeriodsStatusDisplayComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line: component-selector
                selector: 'uk-vat-period-status-display',
                template: `{{ formatPeriodStatus() }}`
            }]
    }], null, { period: [{
            type: Input
        }] }); })();

class UkVatPeriodsVatNumberComponent {
    get vatNumber() {
        return this.number ? this.number : 'Not provided';
    }
    set vatNumber(value) {
        this.number = value;
    }
}
UkVatPeriodsVatNumberComponent.ɵfac = function UkVatPeriodsVatNumberComponent_Factory(t) { return new (t || UkVatPeriodsVatNumberComponent)(); };
UkVatPeriodsVatNumberComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UkVatPeriodsVatNumberComponent, selectors: [["uk-vat-periods-vat-number"]], inputs: { vatNumber: "vatNumber" }, decls: 8, vars: 1, consts: [[1, "row"], [1, "col-md-2", "col-sm-6", "col-xs-12"], ["for", "vatNumber", 1, "control-label"], [1, "font-weight-bold", "pl-2"]], template: function UkVatPeriodsVatNumberComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label", 2);
        ɵngcc0.ɵɵtext(3, "VAT Number");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(4, "div", 0)(5, "div", 1)(6, "span", 3);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate(ctx.vatNumber);
    } }, styles: ["input.form-control[_ngcontent-%COMP%]{background:none;border:none;color:#000;font-weight:700}"] });
UkVatPeriodsVatNumberComponent.propDecorators = {
    vatNumber: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkVatPeriodsVatNumberComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line: component-selector
                selector: 'uk-vat-periods-vat-number',
                template: "<div class=\"row\">\n  <div class=\"col-md-2 col-sm-6 col-xs-12\">\n    <label for=\"vatNumber\" class=\"control-label\">VAT Number</label>\n  </div>\n</div>\n<div class=\"row\">\n  <div class=\"col-md-2 col-sm-6 col-xs-12\">\n    <span class=\"font-weight-bold pl-2\">{{ vatNumber }}</span>\n  </div>\n</div>\n",
                styles: ["input.form-control{background:none;border:none;color:#000;font-weight:700}"]
            }]
    }], null, { vatNumber: [{
            type: Input
        }] }); })();

class UkVatPeriodsUserMessagesComponent {
    constructor() {
        this.alerts = [];
        this.mispatchText = 'The latest sync with HMRC resulted in a change to the period dates previously stored on Onvio. ' +
            'Please check the VAT projects for this client to ensure all dates are as required.';
    }
    // eslint-disable-next-line accessor-pairs
    set userMessages(messages) {
        this.mapUserMessages(messages);
    }
    mapUserMessages(messages) {
        messages.forEach(userMessage => {
            if (userMessage.message === this.mispatchText) {
                this.alerts.push({
                    type: 'info',
                    closeable: true,
                    msg: 'There was a mismatch when syncing periods with HMRC. The periods have been updated to match the HMRC periods.',
                });
            }
        });
    }
}
UkVatPeriodsUserMessagesComponent.ɵfac = function UkVatPeriodsUserMessagesComponent_Factory(t) { return new (t || UkVatPeriodsUserMessagesComponent)(); };
UkVatPeriodsUserMessagesComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UkVatPeriodsUserMessagesComponent, selectors: [["uk-vat-periods-user-messages"]], inputs: { userMessages: "userMessages" }, decls: 3, vars: 2, consts: [[1, "row"], [1, "col-xs-12", "col-md-12", "col-lg-12"], [3, "inline", "items"]], template: function UkVatPeriodsUserMessagesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "bento-alert", 2);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("inline", true)("items", ctx.alerts);
    } }, directives: [ɵngcc4.BentoAlertComponent], encapsulation: 2 });
UkVatPeriodsUserMessagesComponent.propDecorators = {
    userMessages: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkVatPeriodsUserMessagesComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line: component-selector
                selector: 'uk-vat-periods-user-messages',
                template: "<div class=\"row\">\n  <div class=\"col-xs-12 col-md-12 col-lg-12\">\n    <bento-alert [inline]=\"true\" [items]=\"alerts\"></bento-alert>\n  </div>\n</div>\n"
            }]
    }], function () { return []; }, { userMessages: [{
            type: Input
        }] }); })();

class UkVatPeriodsModule {
}
UkVatPeriodsModule.ɵfac = function UkVatPeriodsModule_Factory(t) { return new (t || UkVatPeriodsModule)(); };
UkVatPeriodsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UkVatPeriodsModule });
UkVatPeriodsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        // Services needed by this module
        UkVatAlertService,
        UkVatPeriodsService,
        UkVatPeriodsUtilsService,
        UkVatDateValidatorService
    ], imports: [[
            // Modules needed by this module
            CommonModule,
            FormsModule,
            HttpClientModule,
            BentoModule,
            NgbModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkVatPeriodsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    // Components defined in this module
                    UkVatPeriodsComponent,
                    UkVatPeriodsVatNumberComponent,
                    UkVatPeriodsTableComponent,
                    UkVatPeriodsStatusDisplayComponent,
                    UkVatPeriodsAddPeriodComponent,
                    UkVatPeriodsUserMessagesComponent,
                ],
                imports: [
                    // Modules needed by this module
                    CommonModule,
                    FormsModule,
                    HttpClientModule,
                    BentoModule,
                    NgbModule,
                ],
                exports: [
                    // Components exported by this module
                    UkVatPeriodsComponent,
                ],
                providers: [
                    // Services needed by this module
                    UkVatAlertService,
                    UkVatPeriodsService,
                    UkVatPeriodsUtilsService,
                    UkVatDateValidatorService
                ],
                entryComponents: [UkVatPeriodsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UkVatPeriodsModule, { declarations: function () { return [UkVatPeriodsComponent, UkVatPeriodsVatNumberComponent, UkVatPeriodsTableComponent, UkVatPeriodsStatusDisplayComponent, UkVatPeriodsAddPeriodComponent, UkVatPeriodsUserMessagesComponent]; }, imports: function () { return [
        // Modules needed by this module
        CommonModule,
        FormsModule,
        HttpClientModule,
        BentoModule,
        NgbModule]; }, exports: function () { return [UkVatPeriodsComponent]; } }); })();

/*
 * Public API Surface of uk-vat-periods
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UkVatPeriodsComponent, UkVatPeriodsModule, UkVatPeriodsService, UkVatPeriodsUtilsService as ɵa, UkVatPeriodsVatNumberComponent as ɵb, UkVatPeriodsTableComponent as ɵc, UkVatPeriodsStatusDisplayComponent as ɵd, UkVatPeriodsAddPeriodComponent as ɵe, UkVatAlertService as ɵf, UkVatDateValidatorService as ɵg, UkVatPeriodsUserMessagesComponent as ɵh };

